import type { TrPageConfigInterface } from '@core/utils/TrPageConfig.interface'
import { useLoadingStore } from '@/stores/loading'
import { useSlugHelper } from '@/router/useSlugHelper'

const Names = {
  fr: 'termes-et-conditions',
  en: 'terms'
}

const Config: TrPageConfigInterface = {
  name: Names.fr,
  path: `/${Names.fr}`,
  alias: `/${Names.en}`,
  meta: {
    title: {
      fr: 'Termes et condititions',
      en: 'Terms and Conditions'
    },
    description: {
      fr: 'Consultez cette page pour prendre connaissance de nos termes et conditions.',
      en: 'See this page for our terms and conditions.'
    }
  },
  component: () => import('@page/terms/Terms.vue'),
  beforeEnter: async (to, from, next) => {
    const loadingStore = useLoadingStore()
    loadingStore.toggleLoading({ set: true })
    next(await useSlugHelper().checkPageSlug(to.path, Names))
  }
}

export { Config }
